// esbuild entry point for the WebOTP route (/webotp/) — the only route.
import PopcornTerm from "./terminal.js";
import { bootWebOTP, onWebOTPReady } from "./webotp_boot.js";

// Each hint is something a visitor would not expect a browser tab to be able to
// do — runtime compilation, real processes, real DNS, a real TLS handshake — so
// the tour is evidence, not a generic Elixir sampler. Tapping populates the
// input; nothing auto-runs, so a visitor is never surprised by code they didn't
// read.
const HINTS = [
  ["defmodule Hi do\n  def there, do: :world\nend", "compile a module, right here"],
  ["Hi.there()", "…then call it"],
  ["Enum.map([1, 2, 3], &(&1 * 2))", "stock stdlib"],
  ["Task.async(fn -> Enum.sum(1..1_000_000) end) |> Task.await()", "real processes"],
  [":crypto.hash(:sha256, \"hello\") |> Base.encode16()", "OpenSSL, in wasm"],
  // Slice 2. These two are the tab reaching the actual internet through stock
  // Erlang: a real DNS answer, and a real TLS handshake terminated in this tab.
  [":inet.gethostbyname(~c\"elixir-lang.org\")", "real DNS, from a browser tab"],
  [":httpc.request(~c\"https://api.github.com/zen\")", "HTTPS — TLS handshake in this tab"],
  // Slice 3. The one that answers "is this a toy?" — a real hex package is
  // fetched, checksummed, unpacked and COMPILED here, macros and all.
  ['Mix.install([{:jason, "~> 1.0"}])', "fetch + compile a real hex package (~17 s)"],
  ['Jason.encode!(%{a: 1})', "…then use it"],
  // Slice C. Stock ExUnit, and the second test fails on purpose — a suite that
  // could only print "all passed" would prove nothing.
  ["ExUnit.start()", "start the test framework"],
  [
    "defmodule Counter do\n" +
      "  use GenServer\n" +
      "  def start_link(n), do: GenServer.start_link(__MODULE__, n)\n" +
      "  def init(n), do: {:ok, n}\n" +
      "  def handle_call(:inc, _from, n), do: {:reply, n + 1, n + 1}\n" +
      "end",
    "something worth testing",
  ],
  [
    "defmodule CounterTest do\n" +
      "  use ExUnit.Case, async: true\n" +
      '  setup do {:ok, pid} = Counter.start_link(0); %{pid: pid} end\n' +
      '  test "it counts", %{pid: pid} do\n' +
      "    assert GenServer.call(pid, :inc) == 1\n" +
      "    assert GenServer.call(pid, :inc) == 2\n" +
      "  end\n" +
      '  test "and this one fails on purpose", do: assert %{a: 1, b: 2} == %{a: 1, b: 3}\n' +
      "end",
    "a real test case, with setup",
  ],
  ["ExUnit.run()", "green dot, red F, and a diff"],
  [":erlang.system_info(:otp_release)", "prove it's OTP"],
];

function renderHints() {
  const bar = document.getElementById("hintbar");
  if (!bar) return;
  bar.innerHTML =
    '<div class="hintbar-title">Try one — tap to load it into the prompt:</div>' +
    '<div class="hintbar-btns"></div>';
  const btns = bar.querySelector(".hintbar-btns");
  for (const [code, desc] of HINTS) {
    const b = document.createElement("button");
    b.className = "hint";
    b.type = "button";
    // Hints are folded onto one line, and stay folded even though the prompt
    // takes whole blocks now (Slice A-0). A chip POPULATES the input without
    // running it — "nothing auto-runs, so a visitor is never surprised by code
    // they didn't read" — and there is no way to put a multi-line block into the
    // input without submitting the complete lines, because `_buf` is a single
    // line by construction. Pasting the same block by hand works and is the
    // path `webotp_repl_multiline_verify.py` gates.
    b.innerHTML = `<code></code><span class="desc"></span>`;
    b.querySelector("code").textContent = code.replace(/\n\s*/g, " ");
    b.querySelector(".desc").textContent = desc;
    b.addEventListener("click", () => PopcornTerm.setInput(code.replace(/\n\s*/g, " ")));
    btns.appendChild(b);
  }
}

// Auto-boot for the CDP harnesses; a human gets the button.
const auto = new URLSearchParams(location.search).has("autojoin");

window.__bootWebOTP = () => {
  const splash = document.getElementById("splash");
  if (splash) splash.classList.add("splash-done");
  const repl = document.getElementById("repl");
  if (repl) repl.style.display = "";
  bootWebOTP();
  onWebOTPReady(renderHints);
};

if (auto) window.__bootWebOTP();
